<template>
  <v-autocomplete
    item-text="Text"
    item-value="Id"
    return-object
    v-bind="$attrs"
    v-on="$listeners"
  ></v-autocomplete>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'k-autocomplete',
  inheritAttrs: false,
  data() {
    return {};
  },
  mounted() {},
  created() {},
  methods: {},
  computed: {
    ...mapGetters({}),
  },
  watch: {},
  components: {},
};
</script>
